import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    claim: 'Claim',
    unlockTime: 'Unlock in {time}',
    left: '{time} left',
  },
};
